import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    link: {
      color: theme.palette.link.main,
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      '&:hover': {
        fontWeight: 400,
      },
    },
  };
});

export { useStyles };
